import { differenceInCalendarDays } from 'date-fns'

import { parseISODate } from './format'
import { UUID_PATTERN } from './patterns'

export const checkStringPattern = (base: string, textToCompare: string) => {
  const keywordString = base.trim().replace(/[^a-zA-Z0-9\s]+/g, '')
  const pattern = new RegExp(`\\b${keywordString}`, 'gi')

  return Boolean(textToCompare.match(pattern))
}

export function pluralize(
  number: number | undefined,
  plural: string,
  singular: string,
): string | undefined {
  if (number === undefined) {
    return undefined
  }

  return number !== 1 ? plural : singular
}

export const pluralizeS = (number: number | undefined) => pluralize(number, 's', '')

export const totalNights = (start: string | Date, end: string | Date): string | undefined => {
  if (Number.isInteger(differenceInCalendarDays(parseISODate(end), parseISODate(start)))) {
    return `${differenceInCalendarDays(parseISODate(end), parseISODate(start))} ${pluralize(
      differenceInCalendarDays(parseISODate(end), parseISODate(start)),
      'nights',
      'night',
    )}`
  }
  return undefined
}

export const checkIfValidUUID = (value: string) => {
  return UUID_PATTERN.test(value)
}

export const pluralizeText = (value = 0, plural: string, singular: string) =>
  value > 1 || value === 0 ? plural : singular

export const capitalizeAcronymsInName = (name: string): string => {
  const acronyms = ['vrbo', 'Vrbo']

  return name
    .split(' ')
    .map(word =>
      acronyms.includes(word.toLowerCase())
        ? word.toUpperCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join(' ')
}

export const humanizeSnakeCase = (snakeCaseString?: string) => {
  return snakeCaseString
    ?.split('_')
    ?.map(word => word.charAt(0).toUpperCase() + word.slice(1))
    ?.join(' ')
}

export const humanizeIdentifier = (input?: string) => {
  return (
    input
      ?.toString()
      ?.replace(/_/g, ' ')
      ?.replace(/([a-z])([A-Z])/g, '$1 $2')
      ?.split(' ')
      ?.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      ?.join(' ') ?? ''
  )
}

export const deduplicate = (array: string[]): string[] => {
  return [...new Set(array)]
}
